var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgClock = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_349",
    width: 20,
    height: 20,
    "data-name": 349,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    d: "M10 20A10 10 0 1 0 0 10a10 10 0 0 0 10 10zm0-18.182A8.182 8.182 0 1 1 1.818 10 8.182 8.182 0 0 1 10 1.818z",
    className: "cls-1",
    "data-name": "Path 36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    d: "M15.192 13.365l-3.364-3.373V4.01H10.01v6.736l3.9 3.909z",
    className: "cls-1",
    "data-name": "Path 37",
    transform: "translate(-.91 -.365)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClock, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/clock.52a934e6.svg";
export { ForwardRef as ReactComponent };